// extracted by mini-css-extract-plugin
export default {"exportButton":"sales-order-details-page_exportButton__qXPui"};